//used to toggle active state
$('body').on('click', '.toggleActiveWrapper li.toggleActive', function (e) {
  var opts = $(this).metadata().activeOpts;
  ht.toggleActive($(this), opts.activeClass);
});
